(function() {
  'use strict';

  function initCarouselSlider(component, isTabbed = false) {
    const sliderEl = isTabbed ? component.querySelector('[id^="Slider-"]') : component.querySelector('[id^="Slider-"]');
    const slider = sliderEl;
    const navContainer = isTabbed ? component.querySelector('.tabbed-carousel__navigation') : null;
    const progressFill = isTabbed && navContainer
      ? navContainer.querySelector('.tabbed-carousel__progress-fill')
      : (isTabbed ? component.querySelector('.tabbed-carousel__progress-fill') : component.querySelector('.carousel-slider__progress-fill'));
    const nextButton = isTabbed && navContainer
      ? navContainer.querySelector('.tabbed-carousel__button--next')
      : (isTabbed ? component.querySelector('.tabbed-carousel__button--next') : component.querySelector('.carousel-slider__button--next'));
    const prevButton = isTabbed && navContainer
      ? navContainer.querySelector('.tabbed-carousel__button--prev')
      : (isTabbed ? component.querySelector('.tabbed-carousel__button--prev') : component.querySelector('.carousel-slider__button--prev'));
    
    if (!slider || !progressFill) return;
    
    // Ensure progress fill is visible and properly initialized
    progressFill.style.display = 'block';
    progressFill.style.width = '0%';

      // Get total number of products/slides
      const slides = slider.querySelectorAll('[id^="Slide-"]');
      const totalProducts = slides.length;
      // Default progress: 100 / number of products (e.g., 4 products = 25%)
      const defaultProgress = totalProducts > 0 ? 100 / totalProducts : 0;
      
      // Track current progress percentage
      let currentProgress = defaultProgress;

      function setProgress(progress) {
        // Clamp progress between defaultProgress and 100%
        currentProgress = Math.min(100, Math.max(defaultProgress, progress));
        progressFill.style.width = `${currentProgress}%`;
        progressFill.style.display = 'block';
      }

      function updateProgress() {
        const scrollLeft = slider.scrollLeft;
        const scrollWidth = slider.scrollWidth - slider.clientWidth;
        
        if (scrollWidth > 0 && scrollLeft > 0) {
          // Calculate progress based on scroll position
          // Progress goes from defaultProgress to 100% as you scroll
          const scrollProgress = (scrollLeft / scrollWidth) * 100;
          const progress = defaultProgress + (scrollProgress * (100 - defaultProgress) / 100);
          setProgress(progress);
        } else {
          // Set default progress when at start (initial state)
          setProgress(defaultProgress);
        }
      }

      // Handle next button click - increment progress
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          const newProgress = Math.min(100, currentProgress + defaultProgress);
          setProgress(newProgress);
        });
      }

      // Handle previous button click - decrement progress
      if (prevButton) {
        prevButton.addEventListener('click', () => {
          const newProgress = Math.max(defaultProgress, currentProgress - defaultProgress);
          setProgress(newProgress);
        });
      }

      // Set initial default progress
      setProgress(defaultProgress);
      
      // Initial update after a short delay to ensure layout is ready
      setTimeout(() => {
        updateProgress();
      }, 100);

      // Update on scroll - using requestAnimationFrame for smooth updates
      let ticking = false;
      slider.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateProgress();
            ticking = false;
          });
          ticking = true;
        }
      });

      // Update on resize
      const resizeObserver = new ResizeObserver(() => {
        updateProgress();
      });
      resizeObserver.observe(slider);

      // Listen for slide changes from slider-component (when isTabbed, component IS the slider-component)
      if (component) {
        component.addEventListener('slideChanged', () => {
          setTimeout(() => updateProgress(), 100);
        });
      }

      if (isTabbed) {
        component._carouselUpdateProgress = updateProgress;
      }
  }

  function initCarouselSliders() {
    // Initialize regular carousel sliders
    const sliderComponents = document.querySelectorAll('.carousel-slider__component');
    sliderComponents.forEach(component => {
      initCarouselSlider(component, false);
    });

    // Initialize tabbed product carousel: slider-component wraps content, pass the slider-component
    const tabbedSliders = document.querySelectorAll('slider-component.tabbed-carousel__slider');
    tabbedSliders.forEach(sliderEl => {
      if (sliderEl.querySelector('.tabbed-carousel__navigation') && sliderEl.querySelector('[id^="Slider-"]')) {
        initCarouselSlider(sliderEl, true);
      }
    });
  }

  // Initialize when DOM is ready
  function initialize() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarouselSliders);
    } else {
      initCarouselSliders();
    }
    
    // Also try after delays for dynamically loaded content
    setTimeout(initCarouselSliders, 500);
    setTimeout(initCarouselSliders, 1000);
  }

  initialize();

  // Listen for tab changes in tabbed product carousel - re-run progress when panel becomes visible
  document.addEventListener('tabbed-carousel-tab-changed', (e) => {
    const panel = e.detail?.panel;
    if (!panel) return;
    setTimeout(() => {
      const sliderComponent = panel.querySelector('slider-component.tabbed-carousel__slider');
      if (sliderComponent?._carouselUpdateProgress) {
        sliderComponent._carouselUpdateProgress();
      }
    }, 150);
  });

  // Listen for tab changes in tabbed product carousel
  document.addEventListener('DOMContentLoaded', () => {
    const tabbedCarousels = document.querySelectorAll('tabbed-product-carousel');
    tabbedCarousels.forEach(carousel => {
      const observer = new MutationObserver(() => {
        setTimeout(() => {
          carousel.querySelectorAll('slider-component.tabbed-carousel__slider').forEach(sliderEl => {
            if (sliderEl.querySelector('.tabbed-carousel__navigation') && sliderEl.querySelector('[id^="Slider-"]')) {
              initCarouselSlider(sliderEl, true);
            }
          });
        }, 100);
      });

      observer.observe(carousel, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['hidden', 'class']
      });
      // Initial run for tabbed sliders in this carousel
      carousel.querySelectorAll('slider-component.tabbed-carousel__slider').forEach(sliderEl => {
        if (sliderEl.querySelector('.tabbed-carousel__navigation') && sliderEl.querySelector('[id^="Slider-"]')) {
          initCarouselSlider(sliderEl, true);
        }
      });
    });
  });
})();
